import React, { useState } from 'react';
import { postJson } from '../services/http';
import TermsOfUse from './TermsOfUse';

/**
 * Check if the current user has already accepted terms.
 * Checks both the dedicated key and the stored user object.
 */
function hasAcceptedTerms() {
  if (localStorage.getItem('termsAcceptedAt')) return true;
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.termsAcceptedAt) return true;
  } catch {}
  return false;
}

/**
 * Wraps protected routes — if the user hasn't accepted Terms of Use,
 * shows the terms with an Accept button instead of the app content.
 */
function TermsAcceptanceGate({ children }) {
  const [accepted, setAccepted] = useState(hasAcceptedTerms);
  const [submitting, setSubmitting] = useState(false);

  const handleAccept = async () => {
    setSubmitting(true);
    try {
      const res = await postJson('/api/users/accept-terms', {});
      if (res.success) {
        // Persist in dedicated key
        localStorage.setItem('termsAcceptedAt', res.termsAcceptedAt);

        // Also update the stored user object so it survives even if the key is lost
        try {
          const user = JSON.parse(localStorage.getItem('user'));
          if (user) {
            user.termsAcceptedAt = res.termsAcceptedAt;
            localStorage.setItem('user', JSON.stringify(user));
          }
        } catch {}

        setAccepted(true);
      }
    } catch (err) {
      console.error('Failed to accept terms:', err);
    } finally {
      setSubmitting(false);
    }
  };

  if (accepted) return children;

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', color: '#222' }}>
      <TermsOfUse hideFooter />
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: '#fff',
        borderTop: '1px solid #ddd',
        padding: '12px 20px',
        display: 'flex',
        justifyContent: 'center',
        zIndex: 1000,
      }}>
        <button
          className="btn btn-primary"
          onClick={handleAccept}
          disabled={submitting}
          style={{ minWidth: 220, fontSize: '1rem', padding: '10px 24px' }}
        >
          {submitting ? 'Saving...' : 'I Accept the Terms of Use'}
        </button>
      </div>
    </div>
  );
}

export default TermsAcceptanceGate;
